import React from "react";
import styled from "styled-components";
import { genIcon } from "oolib/dist/v2/components/Dropdowns/utils/genIcon";
import { colors2, SwitchSingle, UI_BODY_SM_DF } from "oolib";

const StyledFieldSelectorListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const StyledDisplayBlock = styled.div`
    display: flex;
    gap: 0.6rem;
    align-items: center;
`;


const FieldSelectorListItem = ({ icon, display, color, isActive, onChange, disabled = false }) => {

    return (
        <StyledFieldSelectorListItem style={disabled ? { opacity: 0.6 } : undefined}>
            <StyledDisplayBlock>
                {icon && genIcon({icon, color: color || colors2.grey80})}
                <UI_BODY_SM_DF style={{ color: color || colors2.grey80 }}>{display}</UI_BODY_SM_DF>
            </StyledDisplayBlock>
            <SwitchSingle
                option={{ value: true }}
                value={isActive}
                onChange={disabled ? () => {} : onChange}
                disabled={disabled}
                saveValueAsString
                layoutStyle="style2"
            />
        </StyledFieldSelectorListItem>
    )
}

export default FieldSelectorListItem

